import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clientPortalService } from '../../services/clientPortal.service';

// Owns client-portal layout state: auth guard, client info, unread message
// summary (polled every 60s) and logout.
export const useClientLayout = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [clientInfo, setClientInfo] = useState(null);
  const [messageSummary, setMessageSummary] = useState({ unread_count: 0, has_urgent: false, urgent_messages: [] });

  useEffect(() => {
    checkAuth();
    loadMessageSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Refresh message summary periodically
  useEffect(() => {
    const interval = setInterval(loadMessageSummary, 60000); // Every minute
    return () => clearInterval(interval);
  }, []);

  const checkAuth = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
        credentials: 'include',
      });
      if (!res.ok) throw new Error('unauthenticated');
      const data = await res.json();
      if (!['wholesale_client', 'admin'].includes(data.role)) {
        navigate('/client/login');
        return;
      }
      localStorage.setItem('client_user', JSON.stringify(data));
      loadClientInfo();
    } catch {
      localStorage.removeItem('client_user');
      navigate('/client/login');
    }
  };

  const loadClientInfo = async () => {
    try {
      const data = await clientPortalService.getDashboard();
      setClientInfo(data.client_account);
    } catch (error) {
      console.error('Error loading client info:', error);
    }
  };

  const loadMessageSummary = async () => {
    try {
      const data = await clientPortalService.getMessagesSummary();
      setMessageSummary(data);
    } catch (error) {
      console.error('Error loading message summary:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch {
      // ignore network errors on logout
    }
    localStorage.removeItem('client_user');
    navigate('/client/login');
  };

  return {
    navigate,
    sidebarOpen,
    setSidebarOpen,
    clientInfo,
    messageSummary,
    handleLogout,
  };
};
